import React from 'react'
import { useGroup } from '../../../hooks'
import { CONSUMER, ADMIN } from '../../../services/cognito/userGroups'
import PaidConsumerPrimaryLayout from './paid'
import FreeConsumerPrimaryLayout from './free'

const ConsumerPrimaryLayout = () => {
  const { isInGroup } = useGroup()
  const shouldShowPaidLayout = isInGroup([CONSUMER, ADMIN])
  return shouldShowPaidLayout ? <PaidConsumerPrimaryLayout /> : <FreeConsumerPrimaryLayout />
}

export default ConsumerPrimaryLayout
